import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Sidebar from "../Sidebar";
import TopNavbar from "../../top-navbar/TopNav";
import "./resumeParserAI.css";
 
export default function ResumeParserAI() {
  const navigate = useNavigate();
  const [file, setFile] = useState(null);
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
 
  const token = localStorage.getItem("bgc_token");
 
  if (!token) {
    setError("Authentication token not found. Please log in.");
    setLoading(false);
    return;
  }
 
  // ✅ File validation
  const validateFile = (file) => {
    const allowedTypes = [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "text/plain",
    ];
    const maxSize = 5 * 1024 * 1024; // 5 MB
 
    if (!allowedTypes.includes(file.type)) {
      alert("Only PDF, DOC, DOCX, or TXT files are allowed.");
      return false;
    }
    if (file.size > maxSize) {
      alert("File size must be less than 5 MB.");
      return false;
    }
    return true;
  };
 
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile && validateFile(selectedFile)) {
      setFile(selectedFile);
      setResult(null);
    } else {
      e.target.value = "";
    }
  };
 
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) {
      alert("Please select a resume file!");
      return;
    }
 
    setLoading(true);
    setError(null);
    setResult(null);
 
    const formData = new FormData();
    formData.append("file", file);
 
    try {
      const response = await axios.post(
        "https://qa.trueface.co.in/api/employee/resume/parse",
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      setResult(response.data);
    } catch (err) {
      console.error("❌ API Error:", err);
      setError(err.response?.data || "Something went wrong while parsing resume.");
    } finally {
      setLoading(false);
    }
  };
 
  const handleBack = () => {
    navigate("/employee/aiModules");
  };
 
  return (
<div className="emp-dashboard-container">
<Sidebar />
 
      <div className="emp-main-panel">
<TopNavbar />
 
        <div className="upload-wrapper">
<div className="upload-card">
<div className="upload-header">
<button className="back-btn" onClick={handleBack}>
                ← Back
</button>
<h2 className="upload-title">AI Resume Parser</h2>
</div>
 
            <form onSubmit={handleSubmit} className="upload-form">
<div className="file-group">
<label className="file-label">
                  Upload Resume (PDF, DOC, DOCX, or TXT)
</label>
<label className="custom-file-upload">
                  {file ? file.name : "Choose a file"}
<input
                    type="file"
                    accept=".pdf,.doc,.docx,.txt"
                    onChange={handleFileChange}
                  />
</label>
</div>
 
              <button type="submit" className="btn" disabled={loading}>
                {loading ? "Parsing..." : "Parse Resume"}
</button>
</form>
 
            {result && (
<div className="result-card success">
<h3>✅ Parsed Resume Data</h3>
 
                <p>
<strong>Candidate Name:</strong> {result.candidateName || "N/A"}
</p>
 
                <div className="section">
<h4>Education</h4>
                  {result.educationList?.length ? (
                    result.educationList.map((edu, i) => (
<p key={i}>
                         {edu.degree} - {edu.institution} ({edu.year})
</p>
                    ))
                  ) : (
<p>No education info</p>
                  )}
</div>
 
                <div className="section">
<h4>Employment</h4>
                  {result.employmentList?.length ? (
                    result.employmentList.map((emp, i) => (
<p key={i}>
                         {emp.role} - {emp.company} ({emp.years})
</p>
                    ))
                  ) : (
<p>No employment info</p>
                  )}
</div>
 
                <div className="section">
<h4>Anomalies</h4>
<p>
                    {result.anomalies?.length
                      ? result.anomalies.join(", ")
                      : "No anomalies detected"}
</p>
</div>
</div>
            )}
 
            {error && (
<div className="result-card error">
                ❌{" "}
                {typeof error === "string"
                  ? error
                  : JSON.stringify(error, null, 2)}
</div>
            )}
</div>
</div>
</div>
</div>
  );
}